export const SiteMenuItems = [
  {
    name: "menu:site.about",
    icon: "dashboard",
    location: "/#about",
  },
  {
    name: "menu:site.experience",
    icon: "info",
    location: "/#experience",
  },
  {
    name: "menu:site.projects",
    icon: "info",
    location: "/#projects",
  },
  {
    name: "menu:site.education",
    icon: "info",
    location: "/#education",
  },
  {
    name: "menu:site.contact",
    icon: "info",
    location: "/#contact",
  },
];

export const SocialMenuItems = [
  {
    name: "LinkedIn",
    location: "https://www.linkedin.com/in/briannhu/",
  },
  {
    name: "Github",
    location: "https://github.com/BriannHu",
  },
  {
    name: "Instagram",
    location: "https://www.instagram.com/briann.hu/",
  },
  {
    name: "Facebook",
    location: "https://www.facebook.com/brianhu.mcgill/",
  },
];
